import React,  {Component} from 'react';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button/Button';
import PropTypes from 'prop-types';

import { toggleDeleteUserPopup, toggleNotification } from '../../redux/reducers/view';
import { deleteUserRequest } from '../../redux/reducers/deleteUser';
import { getTeamMembersFullRequest } from '../../redux/reducers/teamMembersFull';
import Popup from '../Popup';

import { commonStyles } from '../../styles/styles';
import addUserImage from '../../assets/icon_trash.svg';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import { selectedUser } from '../../redux/selectors';


class DeleteUserPopup extends Component {
  state = {
    modal: true
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
    this.props.toggleDeleteUserPopup(false);
  }
  render() {
    return (
      <MDBContainer>
        {this.props.selectedUser && <MDBModal isOpen={this.props.view.deleteUserPopup} toggle={this.toggle}  centered>
          <MDBModalHeader className="default-color text-white" toggle={this.toggle}>Delete User</MDBModalHeader>
          <MDBModalBody>
            Are you sure you would like to remove {this.props.selectedUser.firstname+' '+this.props.selectedUser.lastname} from your team?
          </MDBModalBody>
          <MDBModalFooter>
          <MDBBtn size="md" color="grey" onClick={this.props.handleDeleteUser}>DELETE</MDBBtn><MDBBtn size="md" className="btn-dark-green" onClick={this.toggle}>CLOSE</MDBBtn>
          </MDBModalFooter>
        </MDBModal>}
      </MDBContainer>
    );
  }
}


// const DeleteUserPopup = ({
//   classes,
//   selectedUserName,
//   handleDeleteUser,
//   handleToggleDeleteUserPopup,
// }) => (
//   <Popup>
//     <div className={classes.popup}>
//       <div className={`${classes.popupContent} ${classes.popupContentInviteDeclineReason}`}>
//         <div className={classes.popupHeader}>
//           <Clear className={classes.closePopup} onClick={handleToggleDeleteUserPopup} />
//           <img src={addUserImage} alt="Icon feather" className={classes.image} />
//           <Typography variant="headline" gutterBottom className={classes.deleteUserPopupHeaderText}>
//             Are you sure you want to delete {selectedUserName} team member?
//           </Typography>
//           <div className={classes.deleteUserPopupButtons}>
//             <Button
//               variant="contained"
//               className={`
//               ${classes.defaultButton}
//                ${classes.orangeButton}
//                 ${classes.deleteUserPopupButton}`}
//               onClick={handleDeleteUser}
//             >
//               DO IT
//             </Button>
//             <Button
//               variant="contained"
//               className={`${classes.defaultButton} ${classes.greyButton} ${
//                 classes.deleteUserPopupButton
//               }`}
//               onClick={handleToggleDeleteUserPopup}
//             >
//               NO
//             </Button>
//           </div>
//         </div>
//       </div>
//     </div>
//   </Popup>
// );

const styles = () => ({
  ...commonStyles,
  deleteUserPopupButton: {
    width: 100,
    minHeight: 27,
  },
  deleteUserPopupHeaderText: {
    padding: '0 50px',
    margin: '30px 0',
    lineHeight: '25px',
    fontSize: 14,
    textAlign: 'center',
    color: '#4A4A4A'
  },
  deleteUserPopupButtons: {
    display: 'flex',
    width: '80%',
    marginBottom: 20,
    justifyContent: 'space-evenly',
  },
});

const mapDispatchToProps = dispatch => ({
  toggleDeleteUserPopup: value => dispatch(toggleDeleteUserPopup(value)),
  deleteUserRequest: () => dispatch(deleteUserRequest()),
  getTeamMembersFullRequest: () => dispatch(getTeamMembersFullRequest()),
  toggleNotification: value => dispatch(toggleNotification(value)),
});

const mapStateToProps = state => ({
  view: state.viewReducer,
  coachFull: state.teamMembersFullReducer,
  deleteUserReducer: state.deleteUserReducer,
  selectedUser: selectedUser(state)
});

export default compose(
  withState('selectedUserName', 'changeSelectedUserName', null),
  withState('selectedUserId', 'changeSelectedUserId', null),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handleDeleteUser: props => () => {
      if (!props.deleteUserReducer.fetching) {

        props.deleteUserRequest();
      //  props.toggleNotification({
      //   value: true,
      //   message: 'User was successfully deleted',
      //   type: 'success',
      // });
      }
    },
    handleToggleDeleteUserPopup: props => e => {
      props.toggleDeleteUserPopup(false);
    },
  }),
  lifecycle({
    componentWillMount() {
      const { coachFull, changeSelectedUserName, changeSelectedUserId } = this.props;
      if (coachFull.users) {
        const user = teamMembersFullReducer.users.find(
          obj => obj.userId === coachFull.selectedTeamMemberId,
        );
        changeSelectedUserName(`${user.firstname} ${user.lastname}`);
        changeSelectedUserId(user.userId);
      }
    },
    componentWillReceiveProps(nextProps) {
      const { deleteUserReducer, toggleNotification, view } = nextProps;
      if (deleteUserReducer.success && !view.notification) {
        toggleNotification({
          value: true,
          message: 'User was successfully deleted',
          type: 'success',
        });
      }
    },
  }),
  withStyles(styles),
)(DeleteUserPopup);

DeleteUserPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  selectedUserName: PropTypes.string,
  handleDeleteUser: PropTypes.func,
  handleToggleDeleteUserPopup: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Components/Popups/DeleteUserPopup.jsx